(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "67eb7a16a178c877f00d1b63";
              window.beaePageSetting.pageTitle = "Komfymed-safety verified, award-winning collagen skincare"; 
              window.beaePageSetting.pageType = "footer";

          let js_EDP1C7FQ = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-v1ta4gx7section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-v1ta4gx7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-v1ta4gx7');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-v1ta4gx7: ', ex)
      };
    

      try {
        let argid = 'beae-ldaecb5mblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ldaecb5m',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ldaecb5m');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ldaecb5m: ', ex)
      };
    

      try {
        let argid = 'beae-p632o1w8section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-p632o1w8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-p632o1w8');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-p632o1w8: ', ex)
      };
    

      try {
        let argid = 'beae-3lx9z5moblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3lx9z5mo',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3lx9z5mo');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3lx9z5mo: ', ex)
      };
    

      try {
        let argid = 'beae-igt78t2rblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-igt78t2r',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-igt78t2r');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-igt78t2r: ', ex)
      };
    

      try {
        let argid = 'beae-3lx9z5moblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3lx9z5mo',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3lx9z5mo');
        args.el = args.els[1];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3lx9z5mo: ', ex)
      };
    

      try {
        let argid = 'beae-igt78t2rblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-igt78t2r',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-igt78t2r');
        args.el = args.els[1];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-igt78t2r: ', ex)
      };
    

      try {
        let argid = 'beae-3lx9z5moblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3lx9z5mo',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3lx9z5mo');
        args.el = args.els[2];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3lx9z5mo: ', ex)
      };
    

      try {
        let argid = 'beae-igt78t2rblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-igt78t2r',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-igt78t2r');
        args.el = args.els[2];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-igt78t2r: ', ex)
      };
    

      try {
        let argid = 'beae-3lx9z5moblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3lx9z5mo',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3lx9z5mo');
        args.el = args.els[3];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3lx9z5mo: ', ex)
      };
    

      try {
        let argid = 'beae-igt78t2rblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-igt78t2r',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-igt78t2r');
        args.el = args.els[3];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-igt78t2r: ', ex)
      };
    

      try {
        let argid = 'beae-naoeegxmsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-naoeegxm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-naoeegxm');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-naoeegxm: ', ex)
      };
    

      try {
        let argid = 'beae-e0dgy3r7block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-e0dgy3r7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-e0dgy3r7');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-e0dgy3r7: ', ex)
      };
    

      try {
        let argid = 'beae-bnoywa6nsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-bnoywa6n',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-bnoywa6n');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-bnoywa6n: ', ex)
      };
    

      try {
        let argid = 'beae-p205w3pjsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-p205w3pj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-p205w3pj');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-p205w3pj: ', ex)
      };
    

      try {
        let argid = 'beae-l8dvz343section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-l8dvz343',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-l8dvz343');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-l8dvz343: ', ex)
      };
    

      try {
        let argid = 'beae-7zfjle2hsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7zfjle2h',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7zfjle2h');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7zfjle2h: ', ex)
      };
    

      try {
        let argid = 'beae-7g2i3maglinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7g2i3mag',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7g2i3mag');
        args.el = args.els[0];
        ((f) => { const m=f.el.querySelector(".beae-linkslist-title"),w=f.el.querySelector(".beae-linkslist");m===null||w===null||m.addEventListener("click",g=>{window.matchMedia("(max-width: 767px)").matches&&w.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7g2i3mag: ', ex)
      };
    

      try {
        let argid = 'beae-ble7yciglinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ble7ycig',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ble7ycig');
        args.el = args.els[0];
        ((f) => { const m=f.el.querySelector(".beae-linkslist-title"),w=f.el.querySelector(".beae-linkslist");m===null||w===null||m.addEventListener("click",g=>{window.matchMedia("(max-width: 767px)").matches&&w.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ble7ycig: ', ex)
      };
    

      try {
        let argid = 'beae-ukxdyu7hsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ukxdyu7h',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ukxdyu7h');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ukxdyu7h: ', ex)
      };
    

      try {
        let argid = 'beae-w2hehbhdlc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-w2hehbhd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-w2hehbhd');
        args.el = args.els[0];
        ((b) => { let h=b.checkLive;function p(x){return{input:x.querySelector('input[name="locale_code"], input[name="country_code"]'),button:x.querySelector("button.beae-current-value"),panel:x.querySelector(".beae-language-results"),search:x.querySelector('input[name="language_filter"]'),resetButton:x.querySelector(".beae-reset-button")}}function f(x,M){const L=b.el.querySelector("form.beae-localization");M.input.value=x.currentTarget.dataset.value,L&&L.submit()}function m(x){x.button.focus(),x.panel.classList.toggle("hidden-dropdown"),x.button.setAttribute("aria-expanded",(x.button.getAttribute("aria-expanded")==="false").toString());const M=x.button.getBoundingClientRect();window.innerHeight-M.bottom,x.panel.style.top="auto",x.panel.style.bottom="100%"}function w(x){return x.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function g(x,M){const L=w(M.search.value),V=x.querySelectorAll(".beae-languages li");V.length,M.resetButton.classList.toggle("hidden",!L),V.forEach(T=>{w(T.querySelector(".beae-language-name").textContent).indexOf(L)>-1?T.classList.remove("beae-hidden"):T.classList.add("beae-hidden")})}function v(x){x.code.toUpperCase()==="ENTER"&&x.preventDefault()}function C(x,M,L){x.stopPropagation(),L.search.value="",g(M,L)}function S(x,M,L){(!M.contains(x.target)||!M.contains(x.relatedTarget))&&($(M,L),L.button.setAttribute("aria-expanded",(L.button.getAttribute("aria-expanded")==="false").toString()))}function $(x,M){M.panel.classList.add("hidden-dropdown"),M.search&&(M.search.value="",g(x,M))}function B(x){const M=p(x);h&&x.addEventListener("focusout",L=>S(L,x,M)),M.button.addEventListener("click",()=>m(M)),x.querySelectorAll(".beae-language-name").forEach(L=>L.addEventListener("click",V=>f(V,M))),M.search&&(M.search.addEventListener("keyup",()=>g(x,M)),M.search.addEventListener("keydown",v)),M.resetButton&&(M.resetButton.addEventListener("click",L=>C(L,x,M)),M.resetButton.addEventListener("mousedown",L=>L.preventDefault()))}b.el.querySelectorAll(".beae-localization").forEach(B) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-w2hehbhd: ', ex)
      };
    

      try {
        let argid = 'beae-zccvfth8lc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zccvfth8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zccvfth8');
        args.el = args.els[0];
        ((y) => { let b=y.checkLive;function h(k){return{input:k.querySelector('input[name="locale_code"], input[name="country_code"]'),button:k.querySelector("button.beae-current-value"),panel:k.querySelector(".beae-country-results"),search:k.querySelector('input[name="country_filter"]'),resetButton:k.querySelector(".beae-reset-button")}}function p(k,x){const M=y.el.querySelector("form.beae-localization");x.input.value=k.currentTarget.dataset.value,M&&M.submit()}function f(k){k.button.focus(),k.panel.classList.toggle("hidden-dropdown"),k.button.setAttribute("aria-expanded",(k.button.getAttribute("aria-expanded")==="false").toString());const x=k.button.getBoundingClientRect();window.innerHeight-x.bottom,k.panel.style.top="100%",k.panel.style.bottom="auto"}function m(k){return k.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function w(k,x){const M=m(x.search.value),L=k.querySelectorAll(".beae-countries li");L.length,x.resetButton.classList.toggle("hidden",!M),L.forEach(V=>{m(V.querySelector(".beae-country-name").textContent).indexOf(M)>-1?V.classList.remove("beae-hidden"):V.classList.add("beae-hidden")})}function g(k){k.code.toUpperCase()==="ENTER"&&k.preventDefault()}function v(k,x,M){k.stopPropagation(),M.search.value="",w(x,M)}function C(k,x,M){(!x.contains(k.target)||!x.contains(k.relatedTarget))&&(S(x,M),M.button.setAttribute("aria-expanded",(M.button.getAttribute("aria-expanded")==="false").toString()))}function S(k,x){x.panel.classList.add("hidden-dropdown"),x.search&&(x.search.value="",w(k,x))}function $(k){const x=h(k);b&&k.addEventListener("focusout",M=>C(M,k,x)),x.button.addEventListener("click",()=>f(x)),k.querySelectorAll(".beae-country-name").forEach(M=>M.addEventListener("click",L=>p(L,x))),x.search&&(x.search.addEventListener("keyup",()=>w(k,x)),x.search.addEventListener("keydown",g)),x.resetButton&&(x.resetButton.addEventListener("click",M=>v(M,k,x)),x.resetButton.addEventListener("mousedown",M=>M.preventDefault()))}y.el.querySelectorAll(".beae-localization").forEach($) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zccvfth8: ', ex)
      };
    

      try {
        let argid = 'beae-gg7jr4a2block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gg7jr4a2',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gg7jr4a2');
        args.el = args.els[0];
        ((P) => { var F;if(P.el){if(P.shape){const R=P.el.closest(".beae-slider-items");R&&!R.hasAttribute("data-svg")&&(R==null||R.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),R.setAttribute("data-svg","true"))}let Z=P.el.querySelector(".beae-image-content-position"),W,U=window.innerWidth>=768&&P.autoHover;var H=Z.querySelector(".beae-img-ratio-control"),I=Z.querySelector(".beae-img-comp-container"),z=Z.querySelector(".beae-img-comp-container--second");if(H&&z){let R=function(D){let j=0,q;G(),U?Z.onmouseover=function(K){Y(K)}:D.onmousedown=function(K){Y(K)},Z.onmouseup=function(){X()},D.ontouchstart=function(K){Y(K)},Z.ontouchend=function(){X()};function G(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{W=z.offsetWidth})}).observe(z),D.style.left&&parseInt(D.style.left)}function Y(K){check=!1,K.preventDefault(),K.clientX?K.clientX:K.touches[0].clientX,parseInt(D.style.left),j=1,Z.onmousemove=function(re){oe(re)},Z.ontouchmove=function(re){oe(re)}}function X(){j=0,check=!0}function oe(K){if(j==0)return!1;q=te(K),q<0&&(q=0),q>100&&(q=100),ae(q)}function te(K){const re=Z.getBoundingClientRect(),ge=(K.changedTouches?K.changedTouches[0].clientX:K.clientX)-re.left;return Math.max(0,Math.min(100,Math.round(ge*100/W)))}function ae(K){D.style.left=K+"%",z.style.clipPath=`polygon(${K}% 0%, ${K}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${K}% 0%, ${K}% 100%)`}};H&&z&&R(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{W=z.offsetWidth})}).observe(z),R(H))})}}let O=(F=P.el)==null?void 0:F.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",Z=>{let W=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(W)return W.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),Z.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gg7jr4a2: ', ex)
      };
    }; if (window.BEAEBASE) {js_EDP1C7FQ()} else {window.BEAEPAGEJS.push(js_EDP1C7FQ)} })(); 